const DARK_TEXT = '#1f1f1f';
const LIGHT_TEXT = '#ffffff';

/**
 * Picks a readable text colour (near-black or white) for an arbitrary
 * admin-chosen background colour using WCAG relative luminance. Accepts
 * 3- and 6-digit hex values; anything unparsable falls back to dark text.
 */
export function readableTextColor(backgroundColor: string): string {
  const hex = backgroundColor.replace('#', '');
  const normalized =
    hex.length === 3
      ? hex
          .split('')
          .map((c) => c + c)
          .join('')
      : hex;

  if (!/^[0-9a-f]{6}$/i.test(normalized)) {
    return DARK_TEXT;
  }

  const [r, g, b] = [0, 2, 4].map((offset) => {
    const channel = parseInt(normalized.slice(offset, offset + 2), 16) / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  });

  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.45 ? DARK_TEXT : LIGHT_TEXT;
}
